import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dateFormat } from '../../utils/common';
import { openAlert, openConfirm } from '../../utils/common';
import '../../assets/css/common.css';
import Pagination from '../../components/UI/Pagination';
import SectionContainer from '../../components/UI/SectionContainer';
import Spinner from '../../components/UI/Spinner';
import noticeService from '../../services/noticeService';

const NoticeListPage = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedIds, setSelectedIds] = useState([]);
  const [allChecked, setAllChecked] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const pageBlock = 5;

  const fetchList = async (page = 1) => {
    setLoading(true);
    try {
      const res = await noticeService.getNoticeList(pageSize, page);

      if (res.success) {
        setList(res.data.notices);
        setTotalCount(res.data.pagination.totalCount);
        setCurrentPage(page);
        setSelectedIds([]);
        setAllChecked(false);
      } else openAlert({ title: '알림', description: res.message });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList(currentPage);
    window.handleBulkDelete = async (ids) => {
      try {
        const result = await noticeService.deleteNotices(ids);
        if (result.success) {
          openAlert({ title: '알림', description: result.message || '공지사항이 성공적으로 삭제되었습니다.' });
          fetchList(currentPage);
        } else {
          openAlert({ title: '오류', description: result.message || '공지사항 삭제에 실패했습니다.' });
        }
      } catch (error) {
        console.error('삭제 오류:', error);
        openAlert({ title: '오류', description: '공지사항 삭제 중 오류가 발생했습니다.' });
      }
    };
    window.handleDelete = async (id) => {
      try {
        const result = await noticeService.deleteNotices([id]);
        if (result.success) {
          openAlert({ title: '알림', description: result.message || '공지사항이 성공적으로 삭제되었습니다.' });
          fetchList(currentPage);
        } else {
          openAlert({ title: '오류', description: result.message || '공지사항 삭제에 실패했습니다.' });
        }
      } catch (error) {
        console.error('삭제 오류:', error);
        openAlert({ title: '오류', description: '공지사항 삭제 중 오류가 발생했습니다.' });
      }
    };
  }, [currentPage]);

  const handleAllChange = e => {
    const checked = e.target.checked;
    setAllChecked(checked);
    setSelectedIds(checked ? list.map(item => item.idx) : []);
  };

  const handleSelect = id => {
    let next = [...selectedIds];
    if (next.includes(id)) next = next.filter(x => x !== id);
    else next.push(id);
    setSelectedIds(next);
    setAllChecked(next.length === list.length);
  };

  const handleBulkDeleteConfirm = () => {
    if (selectedIds.length === 0) return openAlert({ title: '알림', description: '삭제할 게시글을 선택해주세요.' });
    openConfirm({
      title: '삭제하기',
      description: '선택된 공지사항을 삭제하시겠습니까?',
      positive_method: 'handleBulkDelete',
      positive_param: selectedIds,
      negative_method: null,
      negative_param: null,
      positive_btn: '확인',
      negative_btn: '취소',
    });
  };

  return (
    <SectionContainer title="공지사항 관리" className="list">
      <Spinner visible={loading} />
      <div className="search_area">
        <div className="acc_total">
          <h4><b>{list.length}</b>개 검색되었습니다.</h4>
        </div>
        <div className="left">
          <div className="but-flex">
            <button className="btn btn-md primary mr-1" onClick={() => navigate('write')}>공지사항 등록</button>
            <button className="btn btn-lg tertiary" onClick={handleBulkDeleteConfirm}>삭제</button>
          </div>
        </div>
      </div>
      <div className="content_area">
        <div className="table_area">
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" checked={allChecked} onChange={handleAllChange} />
                  </th>
                  <th>No</th>
                  <th>제목</th>
                  <th>등록일</th>
                  <th>수정</th>
                </tr>
              </thead>
              <tbody>
                {list.map((item, idx) => (
                  <tr key={item.idx}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(item.idx)}
                        onChange={() => handleSelect(item.idx)}
                      />
                    </td>
                    <td>{(currentPage - 1) * pageSize + idx + 1}</td>
                    <td className="un_line" onClick={() => navigate(`edit/${item.idx}`)}>{item.title_ko || item.title_en}</td>
                    <td>{dateFormat(item.regdate)}</td>
                    <td>
                      <input type="button" className="btn fourbtn" onClick={() => navigate(`edit/${item.idx}`)} value="수정하기"/>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalCount={totalCount} pageSize={pageSize} pageBlock={pageBlock} onPageChange={setCurrentPage} />
    </SectionContainer>
  );
};

export default NoticeListPage;
